export const config = {
  email: process.env.NEXT_PUBLIC_APP_EMAIL,
  basePath: process.env.NEXT_PUBLIC_BASE_PATH,
};
